import React from 'react';
import styles from './Login.module.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoginForm from './LoginForm';
import LoginPasswordLost from './LoginPasswordLost';
import LoginPasswordReset from './LoginPasswordReset';
import Header from '../Header';
import NotFound from './NotFound';
import AcessoRapido from './AcessoRapido';
//import UserContext from '../../UserContext';
//import NotFound from '../NotFound';

const Login = () => {
  return (
    <section className={styles.login}>
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route path="perdeu" element={<LoginPasswordLost />} />
        <Route path="resetar/:token" element={<LoginPasswordReset />} />
        <Route path="primeiro-acesso/:token" element={<LoginPasswordReset />} />
        {/* <Route path="*" element={<NotFound />} /> */}
        <Route path="acesso-rapido/:token" element={<AcessoRapido />} />
      </Routes>
    </section>
  );
};

export default Login;
